import Tooltip from '@atlaskit/tooltip';
import useText from './hooks/useText';
import { jsx as _jsx } from "react/jsx-runtime";
const SVG_STYLE = {
  overflow: 'visible'
};
export default function Text(props) {
  const {
    dx = 0,
    dy = 0,
    textAnchor = 'start',
    innerRef,
    innerTextRef,
    verticalAnchor,
    alignmentBaseline,
    angle,
    lineHeight = '1em',
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    scaleToFit = false,
    capHeight,
    truncate,
    singleline,
    children,
    ...textProps
  } = props;
  const {
    x = 0,
    fontSize
  } = textProps;
  const {
    wordsByLines,
    startDy,
    transform,
    truncated
  } = useText(props);

  /*
   * NOTE: We may need to change this <g> tag back to a <svg> tag at some point
   *
   * https://github.com/airbnb/visx/issues/971
   *
   * The core developer says the following "This is intentional as it simplifies positioning, rotation, and scaling."
   *
   * We measure the axis labels using the element ref. This works fine in some browsers but firefox
   * adds default sizes to svgs. Whereas chrome will respect empty width/height as null value.
   *
   * We currently don't do very fancy things with this text component so ok to switch to <g> for now.
   *
   * I did have to move the dx/dy translates from x/y attributes to a css transform since they
   * use em to center the text.
   */
  const textComponent = /*#__PURE__*/_jsx("g", {
    ref: innerRef,
    fontSize: fontSize,
    style: {
      ...SVG_STYLE,
      transform: `translate(calc(${dx}), calc(${dy}))`
    },
    children: wordsByLines.length > 0 ? /*#__PURE__*/_jsx("text", {
      ref: innerTextRef,
      transform: transform,
      ...textProps,
      textAnchor: textAnchor,
      children: wordsByLines.map((line, index) => /*#__PURE__*/_jsx("tspan", {
        alignmentBaseline: alignmentBaseline,
        x: x,
        dy: index === 0 ? startDy : lineHeight,
        children: line.words.join(' ')
      }, index))
    }) : null
  });
  if (truncated) {
    var _props$children;
    return /*#__PURE__*/_jsx(Tooltip, {
      tag: "g",
      content: (_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.toString(),
      position: "bottom",
      children: textComponent
    });
  }
  return textComponent;
}